let ja = {
    "translation" : {
        "change_password": "パスワードの再設定",
        "change_password_instruction": "新しいパスワードを入力してください。",
        "execute_change_passoword": "パスワード再設定"
    }
};

export default ja;
